import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {AbstractToolWrapper} from 'app/tool-layer/class/tool-wrapper';
import {ComponentModule} from 'app/component/component.module';
import {SplitsFlatComponent} from 'app/tool-layer/tools/splits-flat/splits-flat.component';

@NgModule({
    imports: [CommonModule, ComponentModule],
    declarations: [SplitsFlatComponent],
    entryComponents: [SplitsFlatComponent],
    providers: [
        {
            provide: AbstractToolWrapper,
            useValue: AbstractToolWrapper.create(SplitsFlatComponent),
            multi: true,
        },
    ],
})
export class SplitsFlatModule {}
